var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStop = function SvgStop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8c0 1.246.392 2.46 1.12 3.47l8.35-8.35A6 6 0 0 0 2 8Zm12 0c0-1.246-.392-2.46-1.12-3.47l-8.35 8.35A6 6 0 0 0 14 8Zm-6 8A8 8 0 1 1 8 0a8 8 0 0 1 0 16Z"
  })));
};
export default SvgStop;